import React, {Fragment, PureComponent} from 'react';
import PropTypes from 'prop-types';
import assign from 'object-assign';
import uuid from 'uuid/v4';


export default class BooleanInput extends PureComponent {
  static propTypes = {
    value: PropTypes.bool,
    onChange: PropTypes.func,
    type: PropTypes.string
  };

  state = {
    id: uuid()
  };

  render() {
    let {children, value, label, onChange, ...props} = this.props;

    return (
      <Fragment>
        <input
            {...props}
            type='checkbox'
            checked={value}
            onChange={event => onChange(event.target.checked)}
            placeholder={label}
            id={`boolean-input=${this.state.id}`} />
        <label htmlFor={`boolean-input=${this.state.id}`}>
          {children}
        </label>
      </Fragment>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/BooleanInput.js